import { HomeWorkoutSequence } from 'fitbeat.gym-core';
import { UserProfile } from 'fitbeat.gym-core';
import React, { FunctionComponent, useEffect } from 'react';
import Orientation from 'react-native-orientation-locker';
import { connect } from 'react-redux';
import { deviceSetupIsOpenSelector, homeWorkoutSessionSelector } from '../selectors/homeWorkoutSelectors';
import { IAppStore } from '../reducer';

interface IProps {
  deviceSetupIsOpen: boolean;
  homeWorkoutSession: HomeWorkoutSequence;
  userProfile: UserProfile | null;
  isGroupWorkout: boolean;
}

const ScreenOrientationHandler: FunctionComponent<IProps> = ({
  deviceSetupIsOpen,
  homeWorkoutSession,
  userProfile,
}) => {
  useEffect(() => {
    Orientation.unlockAllOrientations();
  }, [deviceSetupIsOpen]);

  const rotateDeviceBasedOnOrientation = async (): Promise<void> => {
    const devicesOrientation = await getDevicesOrientation();
    if (devicesOrientation === 'LANDSCAPE-RIGHT') {
      Orientation.lockToLandscapeRight();
    } else {
      Orientation.lockToLandscape();
    }

    const orientation = await getOrientation();
    if (orientation === 'PORTRAIT') {
      await rotateDeviceBasedOnOrientation();
    }
  };

  const getDevicesOrientation = (): Promise<string> => {
    return new Promise((resolve, _) => {
      Orientation.getDeviceOrientation((orientation: string) => {
        resolve(orientation);
      });
    });
  };

  const getOrientation = (): Promise<string> => {
    return new Promise((resolve, _) => {
      Orientation.getOrientation((orientation: string) => {
        resolve(orientation);
      });
    });
  };

  return <></>;
};

const mapStateToProps = (state: IAppStore): Partial<IProps> => ({
  deviceSetupIsOpen: deviceSetupIsOpenSelector(state),
  homeWorkoutSession: homeWorkoutSessionSelector(state),
  userProfile: state.homeWorkouts.userProfile,
  isGroupWorkout: state.homeWorkouts.isGroupWorkout,
});

export const HomeScreenOrientatonHandler = connect(mapStateToProps)(ScreenOrientationHandler);
